import { isSiteDomain } from "../../settings/domainManager";

export function get_shop_uid_from_url() {
  return window.location.pathname.split("/")[1];
}
export function navigate_to_shop(shop_uid) {
  if (isSiteDomain) {
    return "/";
  }
  return "/" + shop_uid;
}

export function navigate_to_shop_from_url() {
  return navigate_to_shop(get_shop_uid_from_url());
}
